import React,{useState} from 'react'
import View from './search-view'
import firebase from '../../firebase'
import { ToastContainer, toast } from 'react-toastify';

function Search() {


    const [formdata,setFormData] = useState({
        email:'',
        pin:'',
        date:'',
        age:''
    })
    
    const{email,pin,date,age} = formdata
  
    const handleChange = name => e =>{
       setFormData({...formdata,[name]:e.target.value})
    }
     
    const onSend = ()=>{
        const db = firebase.firestore()
        db.collection('corona').add({email:email,pin:pin,date:date,age:age})
        toast.success("You'll be notified on your mail")
    }

    const handleSubmit = e=>{
        e.preventDefault()
        try {
            if(email && pin>5 && date && age){
                 onSend()
            } else {
                toast.error("Enter all the fields properly");
            }
        } catch (error) {
            toast.error(error.response);
        }
    }

    return (
        <div>
        <ToastContainer/>
           <View {...({ handleChange, handleSubmit })}/>
       </div>
    )
}

export default Search


//Fetch firebase
// const [check,setcheck] = useState([])
//     useEffect(() => {
       
//         const fetchdata = async ()=> {
//             const db= firebase.firestore()
//             const data = await db.collection("Check").get()
//             setcheck(data.docs.map(doc => doc.data()))
//         }
//         fetchdata()
//     }, [])